{
	"name": "improved-ziggurat",
	"copy": true
}
